import { EnvironmentProviders, inject, makeEnvironmentProviders } from '@angular/core';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
// Rétablissement des imports pour la configuration via Token
import { TranslateHttpLoader, TranslateHttpLoaderConfig, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader'; 
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

// La factory doit maintenant satisfaire le compilateur en n'acceptant que 0 argument
export function createTranslateLoader(): TranslateLoader {
    // Injecter le client HTTP (méthode Angular 20)
    // Le loader se chargera de récupérer le HttpClient via inject()
    // et les chemins via le TRANSLATE_HTTP_LOADER_CONFIG
    inject(HttpClient);
    
    // OBLIGATOIRE : Retour au constructeur sans aucun argument pour résoudre TS2554
    return new TranslateHttpLoader();
}

export function provideTranslate(): EnvironmentProviders {
    const defaultLang = 'en-US';

    const { providers } = TranslateModule.forRoot({
        fallbackLang: defaultLang,
        loader: {
            provide: TranslateLoader,
            useFactory: createTranslateLoader,
        }
    });

    // get value from local storage if exists, otherwise use default
    const langFromStorage = typeof window !== 'undefined'
        ? localStorage.getItem('lang') || defaultLang
        : defaultLang;

    return makeEnvironmentProviders([
        // Rétablissement OBLIGATOIRE du provider TRANSLATE_HTTP_LOADER_CONFIG
        // Le loader a besoin de ce token pour connaître les chemins 'assets/i18n/' et '.json'.
        {
            provide: TRANSLATE_HTTP_LOADER_CONFIG,
            useValue: {
                prefix: 'assets/i18n/', 
                suffix: '.json'
            } as TranslateHttpLoaderConfig
        },
        
        ...(providers ?? []),
        {
            provide: 'APP_INITIALIZER',
            multi: true,
            deps: [TranslateService],
            useFactory: (translate: TranslateService) => () => {
                translate.setFallbackLang(defaultLang);
                // L'APP_INITIALIZER garantit que l'application attend que cette promesse se termine.
                return firstValueFrom(translate.use(langFromStorage)).catch(error => {
                    console.error('Error loading initial language:', error);
                    // Tentative de chargement de la langue par défaut en cas d'erreur
                    return firstValueFrom(translate.use(defaultLang));
                });
            }
        }
    ]);
}
